var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-pdv btn-pdv-green mr-1",attrs:{"type":"button","href":"javascript: void(0);","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('onClick')}}},[_c('i',{staticClass:"fe-plus-circle mr-1"}),_vm._v(" "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }